import { getFirebaseTokenFromLocalStorage } from '@/domains/auth/utils/customSession';
import { fetchRemainingSessionTime } from '@/domains/auth/utils/fetchRemainingSessionTime';
import { isNative } from '@/domains/shared/utils/native';
import { initializeApp } from 'firebase/app';
import {
  indexedDBLocalPersistence,
  browserLocalPersistence,
  initializeAuth,
} from 'firebase/auth';

// Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env['NEXT_PUBLIC_FIREBASE_API_KEY'],
  authDomain: process.env['NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN'],
  projectId: process.env['NEXT_PUBLIC_FIREBASE_PROJECT_ID'],
  storageBucket: process.env['NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET'],
  messagingSenderId: process.env['NEXT_PUBLIC_FIREBASE_SENDER_ID'],
  appId: process.env['NEXT_PUBLIC_FIREBASE_APP_ID'],

  //measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID
};

export const getFirebaseAuthLocalStorageKey = () =>
  'firebase:authUser:' + firebaseConfig.apiKey + ':[DEFAULT]';

const firebaseAuthLocalStorageKey = getFirebaseAuthLocalStorageKey();

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const customGetAuth = async () => {
  if (isNative()) {
    return initializeAuth(app, {
      persistence: indexedDBLocalPersistence,
    });
  }
  const firebaseToken = getFirebaseTokenFromLocalStorage();
  if (firebaseToken) {
    // check if token is expired by posting to api,
    // if token is expired, remove from entire user from local storage
    const { remaining } = await fetchRemainingSessionTime(firebaseToken);

    if (remaining <= 0) {
      console.log('Firebase token in local storage is expired');
      localStorage.removeItem(firebaseAuthLocalStorageKey);
    }
  }
  return initializeAuth(app, { persistence: browserLocalPersistence });
};
